import resetMixin from '@/helper/resetForm'
import tokenClear from '@/helper/eraseToken'

export const pegawaiReg = {
    mixins: [resetMixin, tokenClear],
    methods: {
        // store data pegawai
        async store () {
            try {
                this.isLoading = true
                this.form.nama = this.form.nama.toUpperCase()
                await this.form.post('/api/registrasi/pegawai')
                if (this.form.successful) {
                    this.helper = {
                        perangkat_id: '',
                        errors: ''
                    }
                    this.wilayah = {
                        kecamatan: '',
                        kabkota: '',
                        provinsi: ''
                    }
                    this.isLoading = false
                    this.reset(this.helper)
                    this.$swal({
                        icon: "success",
                        title: "Data berhasil ditambah",
                        type: "success",
                        confirmButtonClass: "btn btn-info",
                        showConfirmButton: true,
                        showCloseButton: true,
                        confirmButtonText: "OKE",
                        allowOutsideClick: false,
                        timer: 5000
                    });
                    this.isSuccess = true
                    localStorage.setItem('saveMode', true)
                } else {
                    this.isSuccess = false
                    this.isLoading = false
                }
            } catch (error) {
                this.isLoading = false
                this.isSuccess = false
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data
                } else {
                    console.log(error)
                }
            }
        }
    }
}

export default pegawaiReg